module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_MT-ee7d772740973b22f66e74dde6277d8d.svg";